import createApiService, { TServiceReturns } from "@lib/create-api-service";
import { API_ROUTES } from "@utils/constants";

import { ORDER_LABEL_PAPER_SIZE } from "../constants";

type TShipmentLabelResponse = {
  binaryData: string;
};

const shipmentLabelService = createApiService<TShipmentLabelResponse, unknown>({
  method: "POST",
  url: API_ROUTES.SHIPMENTS_LABELS,
});

export const loadShipmentLabel = async (shipmentId: string): Promise<TServiceReturns<string, unknown>> => {
  try {
    const data = {
      shipmentIds: [shipmentId],
      paperSize: ORDER_LABEL_PAPER_SIZE,
    };
    const response = await shipmentLabelService({ data });

    if (!response.isSuccess) {
      throw new Error(response.error?.message);
    }

    return { isSuccess: true, data: response.data?.binaryData };
  } catch (err) {
    console.error(err);
    return { isSuccess: false };
  }
};
